import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _chargeDetails = {
    price: 'DOUBLE',
    totalPrice: 'google.protobuf.DoubleValue',
    discount: 'google.protobuf.DoubleValue',
    tax: 'google.protobuf.DoubleValue',
};
var _createSubscriptionRequest = { subscription: '_subscription' };
var _createSubscriptionResponse = { subscription: '_subscription' };
var _discount = { value: 'DOUBLE' };
var _getSubscriptionRequest = {};
var _getSubscriptionResponse = { subscription: '_subscription' };
var _lineItem = {
    chargeDetails: '_chargeDetails',
    productDetails: '_productDetails',
};
var _lineItemChargeDetails = { chargeDetails: '_chargeDetails' };
var _productDetails = { weight: 'google.protobuf.DoubleValue' };
var _shipmentDetails = {
    discount: 'google.protobuf.DoubleValue',
    tax: 'google.protobuf.DoubleValue',
};
var _shippingInfo = { shipmentDetails: '_shipmentDetails' };
var _subscription = {
    dateCreated: 'google.protobuf.Timestamp',
    lineItems: '_lineItem',
    totals: '_totals',
    shippingInfo: '_shippingInfo',
    subscriptionOptionInfo: '_subscriptionOptionInfo',
};
var _subscriptionOptionInfo = { discount: '_discount' };
var _totals = {
    subtotal: 'DOUBLE',
    shipping: 'DOUBLE',
    shippingAfterTax: 'DOUBLE',
    shippingBeforeTax: 'DOUBLE',
    tax: 'DOUBLE',
    discount: 'DOUBLE',
    total: 'DOUBLE',
    weight: 'google.protobuf.DoubleValue',
};
var _updateShippingAddressRequest = {};
var _updateShippingAddressResponse = { subscription: '_subscription' };
var _updateTotalsRequest = {
    totals: '_totals',
    lineItemsChargeDetail: '_lineItemChargeDetails',
};
var _updateTotalsResponse = { subscription: '_subscription' };
function resolveWixSubscriptionsApiV1SubscriptionsApiUrl(opts) {
    var domainToMappings = {
        'www.wixapis.com': [
            {
                srcPath: '/stores/v1/subscriptions',
                destPath: '/v1/subscriptions',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/wix-ecommerce-subscriptions',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/subscriptions-server',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/subscriptions-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/subscriptions-server',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
export function createSubscription(payload) {
    var _a = serializer(_createSubscriptionRequest, {
        _chargeDetails: _chargeDetails,
        _discount: _discount,
        _lineItem: _lineItem,
        _productDetails: _productDetails,
        _shipmentDetails: _shipmentDetails,
        _shippingInfo: _shippingInfo,
        _subscription: _subscription,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _totals: _totals,
    }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createSubscriptionResponse, {
        _chargeDetails: _chargeDetails,
        _discount: _discount,
        _lineItem: _lineItem,
        _productDetails: _productDetails,
        _shipmentDetails: _shipmentDetails,
        _shippingInfo: _shippingInfo,
        _subscription: _subscription,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _totals: _totals,
    }).fromJSON;
    function __createSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription',
            method: 'POST',
            methodFqn: 'wix.subscriptions.api.v1.SubscriptionsApi.CreateSubscription',
            url: resolveWixSubscriptionsApiV1SubscriptionsApiUrl({
                protoPath: '/v1/subscriptions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createSubscription.fromReq = fromReq;
    __createSubscription.__isAmbassador = true;
    return __createSubscription;
}
export function getSubscription(payload) {
    var _a = serializer(_getSubscriptionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSubscriptionResponse, {
        _chargeDetails: _chargeDetails,
        _discount: _discount,
        _lineItem: _lineItem,
        _productDetails: _productDetails,
        _shipmentDetails: _shipmentDetails,
        _shippingInfo: _shippingInfo,
        _subscription: _subscription,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _totals: _totals,
    }).fromJSON;
    function __getSubscription(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription',
            method: 'GET',
            methodFqn: 'wix.subscriptions.api.v1.SubscriptionsApi.GetSubscription',
            url: resolveWixSubscriptionsApiV1SubscriptionsApiUrl({
                protoPath: '/v1/subscriptions/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSubscription.fromReq = fromReq;
    __getSubscription.__isAmbassador = true;
    return __getSubscription;
}
export function updateShippingAddress(payload) {
    var _a = serializer(_updateShippingAddressRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateShippingAddressResponse, {
        _chargeDetails: _chargeDetails,
        _discount: _discount,
        _lineItem: _lineItem,
        _productDetails: _productDetails,
        _shipmentDetails: _shipmentDetails,
        _shippingInfo: _shippingInfo,
        _subscription: _subscription,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _totals: _totals,
    }).fromJSON;
    function __updateShippingAddress(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription',
            method: 'POST',
            methodFqn: 'wix.subscriptions.api.v1.SubscriptionsApi.UpdateShippingAddress',
            url: resolveWixSubscriptionsApiV1SubscriptionsApiUrl({
                protoPath: '/v1/subscriptions/{id}/updateShippingAddress',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateShippingAddress.fromReq = fromReq;
    __updateShippingAddress.__isAmbassador = true;
    return __updateShippingAddress;
}
export function updateTotals(payload) {
    var _a = serializer(_updateTotalsRequest, { _chargeDetails: _chargeDetails, _lineItemChargeDetails: _lineItemChargeDetails, _totals: _totals }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTotalsResponse, {
        _chargeDetails: _chargeDetails,
        _discount: _discount,
        _lineItem: _lineItem,
        _productDetails: _productDetails,
        _shipmentDetails: _shipmentDetails,
        _shippingInfo: _shippingInfo,
        _subscription: _subscription,
        _subscriptionOptionInfo: _subscriptionOptionInfo,
        _totals: _totals,
    }).fromJSON;
    function __updateTotals(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.stores.v1.subscription',
            method: 'POST',
            methodFqn: 'wix.subscriptions.api.v1.SubscriptionsApi.UpdateTotals',
            url: resolveWixSubscriptionsApiV1SubscriptionsApiUrl({
                protoPath: '/v1/subscriptions/{id}/updateTotals',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTotals.fromReq = fromReq;
    __updateTotals.__isAmbassador = true;
    return __updateTotals;
}
//# sourceMappingURL=http.impl.js.map